'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var GlobalConst = require('../../types/GlobalConst');

var VerticalScrollBar = React.createClass({
  propTypes: {
    size: React.PropTypes.object.isRequired,
    value: React.PropTypes.number.isRequired
  },

  render: function () {
    var length1 = 59;
    var length2 = 21;
    var contentStyle;
    var barHeight;
    var actualProgress;
    var style;
    var topBarStyle;
    var bottomBarStyle;

    style = {
      width: this.props.size.width,
      height: this.props.size.height,
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      backgroundColor: this.props.backgroundColor
    };

    topBarStyle = {
      position: 'absolute',
      left: '0px',
      top: '0px',
      width: '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    bottomBarStyle = {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    barHeight = (this.props.size.height * length2) / length1;
    if (this.props.value == 100) {
      actualProgress = this.props.size.height - barHeight - 13;
    } else {
      actualProgress = (this.props.size.height - 30 - barHeight) * (this.props.value / 100) + 15;
    }

    contentStyle = {
      position: 'absolute',
      left: '2px',
      top: actualProgress + 'px',
      width: parseInt(this.props.size.width - 2, 10) + 'px',
      height: barHeight,
      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      border: 'none'
    };


    return (<div style={style}>
      <img style={topBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-top.png')}/>
      <img style={bottomBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-bottom.png')}/>
      <div style={contentStyle}/>
    </div>);
  }
});

var HorizontalScrollBar = React.createClass({

  propTypes: {
    size: React.PropTypes.object.isRequired,
    value: React.PropTypes.number.isRequired
  },


  render: function () {
    var style;
    var leftBarStyle;
    var rightBarStyle;
    var contentStyle;
    var barWidth;
    var actualProgress;
    var length1 = 59;
    var length2 = 21;

    style = {
      width: this.props.size.width,
      height: this.props.size.height,
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      backgroundColor: this.props.backgroundColor
    };

    leftBarStyle = {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    rightBarStyle = {
      position: 'absolute',
      right: '0px',
      top: '0px',
      height: '12px',
      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
    };

    barWidth = (this.props.size.width * length2) / length1;
    if (this.props.value == 100) {
      actualProgress = this.props.size.width - barWidth - 13;
    } else {
      actualProgress = (this.props.size.width - 30 - barWidth) * (this.props.value / 100) + 15;
    }

    contentStyle = {
      position: 'absolute',
      top: '2px',
      left: actualProgress + 'px',
      width: barWidth + 'px',
      height: parseInt(this.props.size.height - 2, 10) + 'px',
      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
      border: 'none'
    };

    return (<div style={style}>
      <img style={leftBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-left.png')}/>
      <img style={rightBarStyle} src={assetsHelper.getAsset('scrollbar/scrollbar-right.png')}/>
      <div style={contentStyle}/>
    </div>);
  }
});


/**
 * 组件滚动条实现
 */
var ScrollBar = React.createClass({
  propTypes: {
    isHorizontal: React.PropTypes.bool.isRequired,
    size: React.PropTypes.object.isRequired,
    value: React.PropTypes.number.isRequired,
    backgroundColor: React.PropTypes.string.isRequired
  },

  render: function () {
    var barSize = {
      width: this.props.size.width - 2,
      height: this.props.size.height - 2
    };
    var style = {
      width: barSize.width,
      height: barSize.height
    };

    if (this.props.isHorizontal) {
      return (<HorizontalScrollBar
        style={style}
        size={barSize}
        value={this.props.value}
        backgroundColor={this.props.backgroundColor}
      />);
    }

    return (<VerticalScrollBar
      style={style}
      size={barSize}
      value={this.props.value}
      backgroundColor={this.props.backgroundColor}
    />);
  },

  getContentBound : function(){}
});

module.exports = ScrollBar;




/** WEBPACK FOOTER **
 ** ./src/views/common/ScrollBar.jsx
 **/